module.exports = __webpack_public_path__ + "static/media/loader_dark.66c2d057.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/loader_dark.svg
// module id = 258
// module chunks = 1